<template>
  <DashboardMenu />
  <div class="container">
    <div class="row">
      <h1 class="h1">Настройки</h1>
    </div>

    <div class="mdc-card">
      <div class="mdc-card-wrapper__text-section">
        <div class="card__title">Список действий</div>
        <div class="flex">
          <button class="mdc-button" @click="updateDTSG">
            <span class="mdc-button__ripple"></span>
            <span class="mdc-button__label">Обновить DTSG токены</span>
          </button>
          <!-- <span v-if="liveDonorsWithoutDtsgCount > 0"> -->
              - {{ liveDonorsWithoutDtsgCount }} донор(ов) без DTSG токена
          <!-- </span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardMenu from '@/components/DashboardMenu.vue';

export default {
  data() {
    return {
      liveDonorsWithoutDtsgCount: 0
    };
  },
  methods: {
    async updateDTSG() {
      try {
        const token = localStorage.getItem('adminAuthToken');
        await this.axios.get('iyt88m76r1m19cr5/updateDTSG', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        // console.log(resp);
        this.showToaster('Запрос на обновление отправлен.');
      } catch (err) {
        // localStorage.removeItem('adminAuthToken');
        // console.log('fail')
        // console.log(err);
      }
    },
    showToaster(msg) {
      this.$toast.show(msg, {
        position: 'top'
        // duration: false,
      });
    },
    async getLiveDonorsWithoutDtsgCount() {
      try {
        const token = localStorage.getItem('adminAuthToken');
        const resp = await this.axios.get('donors/live/no_dtsg/count', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        // console.log(resp);
        this.liveDonorsWithoutDtsgCount = resp.data._count.id;
        // this.showToaster('Запрос на обновление отправлен.');
      } catch (err) {
        // localStorage.removeItem('adminAuthToken');
        // console.log('fail')
        // console.log(err);
      }
    }
  },
  updated() {
    this.getLiveDonorsWithoutDtsgCount();
  },
  mounted() {},
  components: { DashboardMenu }
};
</script>

<style lang="scss" scoped>
@import '../styles/material-components-web.min.css';

.success {
  color: green;
  font-weight: bold;
}

.error {
  color: red;
  font-weight: bold;
}

.container {
  flex-direction: column;
  width: 1280px;
  max-width: 90%;
  margin: 0 auto;
}

.mdc-data-table__header-cell {
  height: 56px;
  font-weight: bold;
}

.stats-columns {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.stats-column {
  width: 25%;
  padding: 10px;
}

.mdc-card-wrapper__text-section {
  padding: 16px;
}

.card__title {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 1.25rem;
  line-height: 2rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  text-decoration: inherit;
  text-transform: inherit;
}

.card__subhead {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  text-decoration: inherit;
  text-transform: inherit;
  opacity: 0.6;
}

.card__supporting-text {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  text-decoration: inherit;
  text-transform: inherit;
  opacity: 0.6;
}

.select-mode-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

select {
  padding: 8px 12px;
  border: 1px solid #333;
  opacity: 0.6;
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: 0.0178571429em;
}

.mdc-data-table__pagination-navigation a {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-weight: bold;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.47);
  font-size: 24px;
  cursor: pointer;
  &:hover {
    color: rgba(0, 0, 0, 0.87);
    transition: 0.3s all ease;
  }
}

.mdc-data-table__pagination-navigation .pagination-link-wrapper {
  margin-right: 5px;
  width: 48px;
  height: 48px;
  padding: 12px;
}

.mdc-data-table__pagination-navigation button {
  display: flex;
  justify-content: center;
  align-items: center;
}

.mdc-button {
  color: #333;
  border: 1px solid #333;
  width: 20%;
  display: flex;
  margin: 15px;
}

.flex {
  display: flex;
  width: 100%;
  align-items: center;
}
// .danger {
//   background: rgb(240, 128, 128, 0.7);
// }

// .success {
//   background: rgba(144, 238, 144, 0.7);
// }
</style>